export enum Theme {
  action = 'action',
  neutral = 'neutral'
}

export enum Variant {
  solid = 'solid',
  ghost = 'ghost',
  outline = 'outline'
}

export enum Size {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg'
}

export interface CommonProps {
  size?: Size;
  style?: React.CSSProperties;
}

export interface ButtonProps {
  buttonTheme?: Theme;
  variant?: Variant;
  href?: string;
  onClick?: any;
  colorizeSVG?: boolean;
  disabled?: boolean;
}

export interface RouterButtonProps {
  colorizeSVG?: boolean;
  disabled?: boolean;
}

export interface TabProps {
  active?: boolean;
  onClick?: any;
}
